import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { GlowOrb } from '@/components/effects/glow-orb';
import { useRequireStep } from '../hooks/use-require-registration-step';
import { useResultReveal } from '../hooks/use-result-reveal';
import { LoadingPhase } from './test-result-loading';
import { PassResult, FailResult } from './test-result-reveal';

type ResultState = { passed: boolean; retryAt?: string };

export function TestResultPage(): ReactNode {
  useRequireStep('result');
  const state = (useLocation().state ?? {}) as ResultState;
  const loading = useResultReveal(state.passed);

  return (
    <div className="relative flex min-h-dvh items-center justify-center bg-void px-md py-lg sm:px-base sm:py-xl">
      <GlowOrb />
      <div className="relative z-10 w-full max-w-[420px]">
        {loading ? (
          <LoadingPhase />
        ) : state.passed ? (
          <PassResult />
        ) : (
          <FailResult {...(state.retryAt ? { retryAt: state.retryAt } : {})} />
        )}
      </div>
    </div>
  );
}
